(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("myPointsLeaderboardResource", ["$resource", myPointsLeaderboardResource]);
    function myPointsLeaderboardResource($resource) {
        return $resource("/api/account/pointsLeaderboards/:leaderboard/:id", { leaderboard: "@leaderboard", id: "@id" }, {
            getSiteLeaderboard: {
                method: "GET",
                params: { leaderboard: "site" }
            },
            getOrganizationLeaderboard: {
                method: "GET",
                params: { leaderboard: "organization" }
            },
            getGroupLeaderboard: {
                method: "GET",
                params: { leaderboard: "group" }
            }
        });
    }
}());
